// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import {
  StyledMobileBoxItem,
  StyledMobileBoxItemRow,
} from '../../../utils/Styles/DataBoxStyles';

const PartyBookMarkedTableMobile = ({
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  bookMarked,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  onBookMarkedItemClick,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  getFormattedCreatedDate,
}) => {
  return (
    <div>
      {/* TODO: Fix this the next time the file is edited. */}
      {/* eslint-disable-next-line react/prop-types */}
      {bookMarked.map(item => (
        <StyledMobileBoxItem
          key={item.createdAt}
          onClick={() => onBookMarkedItemClick(item.activityId)}
        >
          <StyledMobileBoxItemRow>
            {getFormattedCreatedDate(item)} {item.activity.title}{' '}
            {item.creator.memberName}
          </StyledMobileBoxItemRow>
        </StyledMobileBoxItem>
      ))}
    </div>
  );
};

export default PartyBookMarkedTableMobile;
